const { Swiper } =
  await import(`./swiper-core.js?v=${Date.now()}`);
const { Navigation } =
  await import(`./navigation.js?v=${Date.now()}`);
import "./create-element-if-not-defined.js";
class swiperSlider extends HTMLElement {
  constructor() {
    super();
    const swiperSliderElement = this;
    const spvMobile = swiperSliderElement.dataset.slidesPerViewMobile;
    const spvDesktop = swiperSliderElement.dataset.slidesPerViewDesktop;
    const spaceBetween = swiperSliderElement.dataset.spaceBetween;
    const gridOnMobile = swiperSliderElement.dataset.gridOnMobile;
    if (gridOnMobile === "true") {
      if (window.innerWidth > 768) {
        new Swiper(swiperSliderElement, {
          modules: [Navigation],
          slidesPerView: spvMobile ? Number(spvMobile) : 2.2,
          spaceBetween: Number(spaceBetween),
          loop: true,
          breakpoints: {
            768: {
              slidesPerView: spvDesktop ? Number(spvDesktop) : 3.2,
              spaceBetween: Number(spaceBetween)
            }
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
          }
        });
      }
    } else {
      new Swiper(swiperSliderElement, {
        modules: [Navigation],
        slidesPerView: spvMobile ? Number(spvMobile) : 2.2,
        spaceBetween: Number(spaceBetween),
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: spvDesktop ? Number(spvDesktop) : 3.2,
            spaceBetween: Number(spaceBetween)
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      });
    }
  }
}
if (customElements.get("swiper-slider") === void 0) {
  customElements.define("swiper-slider", swiperSlider);
}
